import {setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {PlayerEnums} from '../../../../shared/GameEnums'
import {RoomClientState} from '../RoomClientState.ts'
import {socket} from '../EntryShared'
import {UIRoomCenterSettingsSpeedView} from './UIRoomCenterSettingsSpeedView'

export enum UIRoomCenterSettingSpeedType {
    BotSpeed, GameSpeed
}

export class UIRoomCenterSettingsSpeedController {
    readonly type: UIRoomCenterSettingSpeedType
    private readonly views: UIRoomCenterSettingsSpeedView
    private _currentSetting: keyof typeof PlayerEnums.GameSpeedSettings

    constructor(container: HTMLDivElement, type: UIRoomCenterSettingSpeedType) {
        this.type = type
        this.views = new UIRoomCenterSettingsSpeedView(container, this.type)
        this.currentSetting = this.views.speedDefaultSetting
    }

    get currentSetting(): keyof typeof PlayerEnums.GameSpeedSettings {
        return this._currentSetting
    }

    set currentSetting(value: keyof typeof PlayerEnums.GameSpeedSettings) {
        this._currentSetting = value
        setElementInnerHTML(this.views.speedInput, {key: `strings:colonistCommon.SpeedSettings.${this.currentSetting}`})
    }

    update(newRoomState: RoomClientState) {
        this.updateSpeedSettings(this.views.getSetting(newRoomState, this.type))

        this.views.container.classList.toggle('selected', this.views.speedInput.innerHTML != this.views.speedDefaultSetting)
    }

    private updateSpeedSettings(newSetting: keyof typeof PlayerEnums.GameSpeedSettings) {
        const optionsArray = this.views.speedOptions
        const currentIndex = optionsArray.indexOf(this.currentSetting)
        const newIndex = optionsArray.indexOf(newSetting)
        if(currentIndex != newIndex) this.currentSetting = optionsArray[newIndex]
    }

    load(roomState: RoomClientState) {
        this.initSpeedSettings(roomState)
    }

    private initSpeedSettings(roomState: RoomClientState) {
        const {
            speedDivBody: footerDiv,
            speedRightArrow: rightArrow,
            speedLeftArrow: leftArrow,
            speedOptions: optionsArray,
            speedSocketCommand: socketCommand,
        } = this.views

        if(UIRoomCenterSettingsSpeedController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest'
            rightArrow.classList.toggle('hidden', true)
            leftArrow.classList.toggle('hidden', true)
            setElementOnClick(rightArrow, () => undefined)
            setElementOnClick(leftArrow, () => undefined)
            return
        }
        footerDiv.className = 'option_body'
        rightArrow.classList.toggle('hidden', false)
        leftArrow.classList.toggle('hidden', false)
        setElementOnClick(rightArrow, () => {
            const currentIndex = optionsArray.indexOf(this.currentSetting)
            let newIndex = currentIndex - 1
            if(newIndex < 0) newIndex = optionsArray.length - 1
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        })

        setElementOnClick(leftArrow, () => {
            const currentIndex = optionsArray.indexOf(this.currentSetting)
            let newIndex = currentIndex + 1
            if(newIndex >= optionsArray.length) newIndex = 0
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        })
    }

    updateInteractabilityOfElements(roomState: RoomClientState) {
        this.load(roomState)
    }

    private static isGuest(roomState: RoomClientState): boolean {
        return socket.controller.session.id != roomState.hostSession.userSessionId
    }
}
